import React, { useCallback } from "react";
import { TextField } from "@mui/material";
import { formatPhoneAsYouType, isPhoneSentinel } from "../utils/phone";

/**
 * Campo de telefone com máscara dinâmica (libphonenumber AsYouType).
 * Valor controlado: string de exibição; use toE164Digits no submit.
 */
export default function PhoneField({
  name,
  value,
  onChange,
  defaultCountry = "BR",
  label,
  error,
  helperText,
  fullWidth = true,
  disabled,
  required,
  placeholder,
  InputProps,
}) {
  const displayValue =
    value == null ? "" : isPhoneSentinel(String(value)) ? String(value) : String(value);

  const handleChange = useCallback(
    (e) => {
      const incoming = e.target.value;
      if (isPhoneSentinel(String(value ?? ""))) {
        onChange(e);
        return;
      }
      if (!incoming) {
        onChange({ target: { name, value: "" } });
        return;
      }
      const formatted = formatPhoneAsYouType(incoming, defaultCountry);
      onChange({ target: { name, value: formatted } });
    },
    [name, onChange, value, defaultCountry]
  );

  return (
    <TextField
      name={name}
      label={label}
      value={displayValue}
      onChange={handleChange}
      fullWidth={fullWidth}
      error={!!error}
      helperText={helperText}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      autoComplete="tel"
      InputProps={InputProps}
    />
  );
}
